import React from 'react';

import { AdornedInput, Adornment, FormField, Heading, Label } from '@zillow/constellation';
import { CurrencyInput } from '@zillow/zrs-comet';

import type { Section } from '../../../../../models';
import { CURRENCY_INPUT_PLACEHOLDER } from '../../../../../constants/stringConstants';
import YesAndNoExpansion from '../../../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  annualCostsField: string;
  knowAnnualCostsUtilityProviderField: string;
  setSectionValues: (keyValuePairs: object) => void;
  utilityName: string;
};

export default function UtilitiesOwnRentalProperty({
  section,
  setSectionValues,
  utilityName,
  annualCostsField,
  knowAnnualCostsUtilityProviderField,
}: Props): JSX.Element {
  function onAnnualCostsChange(event): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [annualCostsField]: value,
    });
  }

  function onNoKnowAnnualCostsUtilityProviderField(): void {
    setSectionValues({
      [knowAnnualCostsUtilityProviderField]: false,
    });
  }

  function onYesKnowAnnualCostsUtilityProviderField(): void {
    setSectionValues({
      [knowAnnualCostsUtilityProviderField]: true,
    });
  }

  return (
    <>
      <Heading level={6} marginBottom="sm">
        {utilityName}
      </Heading>
      <FormField
        label={
          <Label>{`Do you know the annual costs of ${utilityName.toLowerCase()} from the utility provider that provided the primary service during the
        previous 12 months?`}</Label>
        }
        control={
          <YesAndNoExpansion
            yesActive={section.getFieldValue(knowAnnualCostsUtilityProviderField)}
            yesHandler={onYesKnowAnnualCostsUtilityProviderField}
            noHandler={onNoKnowAnnualCostsUtilityProviderField}
          >
            <FormField
              label={<Label>{`What are the annual costs?`}</Label>}
              control={
                <AdornedInput
                  input={
                    <CurrencyInput
                      value={section.getFieldValue(annualCostsField)}
                      placeholder={CURRENCY_INPUT_PLACEHOLDER}
                      onChange={onAnnualCostsChange}
                    />
                  }
                  leftAdornment={<Adornment>$</Adornment>}
                />
              }
            />
          </YesAndNoExpansion>
        }
      />
    </>
  );
}
